document.addEventListener("DOMContentLoaded", function () {
  var input = document.getElementById("HeaderSearchInput");
  var wrapper = document.getElementById("PredictiveSearchWrapper");
  var resultsList = document.getElementById("PredictiveSearchResults");
  var suggestionsList = document.getElementById("PredictiveSearchSuggestions");
  var collectionsList = document.getElementById("PredictiveSearchCollections");
  var moreLink = document.getElementById("PredictiveSearchMoreLink");

  if (
    !input ||
    !wrapper ||
    !resultsList ||
    !suggestionsList ||
    !collectionsList ||
    !moreLink
  )
    return;

  var controller = null;
  var debounceTimer = null;
  var currentQuery = "";

  input.addEventListener("input", function () {
    var query = input.value.trim();
    currentQuery = query;

    console.log('currentQuery', currentQuery)

    if (!query.length) {
      wrapper.hidden = true;
      resultsList.innerHTML = "";
      suggestionsList.innerHTML = "";
      collectionsList.innerHTML = "";
      var queryLabel = document.getElementById("PredictiveSearchQueryText");
        if (queryLabel) {
        queryLabel.textContent = currentQuery
            ? `Showing results for: ${currentQuery}`
            : "";
        }
      return;
    }

    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      fetchSuggestions(query);
    }, 200);
  });

  // Hide dropdown when clicking outside
  document.addEventListener("click", function (event) {
    if (!wrapper.contains(event.target) && event.target !== input) {
      wrapper.hidden = true;
    }
  });

  function fetchSuggestions(query) {
    if (controller) controller.abort();
    controller = new AbortController();

    // 🔑 ask for products + collections
    var params = new URLSearchParams({
      q: query,
      "resources[type]": "product,collection",
      "resources[limit]": "6",
    });

    fetch("/search/suggest.json?" + params.toString(), {
      signal: controller.signal,
      headers: { Accept: "application/json" },
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Network error");
        return response.json();
      })
      .then(function (data) {
        renderResults(data);
      })
      .catch(function (error) {
        if (error.name === "AbortError") return;
        console.error("Predictive search error:", error);
        wrapper.hidden = true;
      });
  }

  function renderResults(data) {
    resultsList.innerHTML = "";
    suggestionsList.innerHTML = "";
    collectionsList.innerHTML = "";
    // Update query label
    var queryLabel = document.getElementById("PredictiveSearchQueryText");
    if (queryLabel) {
    queryLabel.textContent = currentQuery
        ? `Showing results for: ${currentQuery}`
        : "";
    }

    var resources = data.resources || {};
    var results = resources.results || {};

    var products = results.products || [];
    var collections = results.collections || [];

    // --- Query suggestions (if S&D exposes them) ---
    var suggestions = [];

    if (
      data.search &&
      data.search.results &&
      Array.isArray(data.search.results.queries)
    ) {
      suggestions = data.search.results.queries;
    } else if (Array.isArray(data.queries)) {
      suggestions = data.queries;
    }

    // LEFT COLUMN: search suggestions
    suggestions.slice(0, 6).forEach(function (sugg) {
      var text =
        (typeof sugg === "string" && sugg) ||
        sugg.text ||
        sugg.query ||
        sugg.term;

      if (!text) return;

      var li = document.createElement("li");
      var a = document.createElement("a");
      a.href = "/search?q=" + encodeURIComponent(text);
      a.className = "predictive-search-suggestion";
      a.textContent = text;
      li.appendChild(a);
      suggestionsList.appendChild(li);
    });

    // LEFT COLUMN: collections (categories)
    collections.slice(0, 6).forEach(function (col) {
      if (!col || !col.url || !col.title) return;

      var li = document.createElement("li");
      var a = document.createElement("a");
      a.href = col.url;
      a.className = "predictive-search-collection";
      a.textContent = col.title;
      li.appendChild(a);
      collectionsList.appendChild(li);
    });

    // RIGHT COLUMN: products
    products.forEach(function (product) {
      var li = document.createElement("li");
      li.setAttribute("role", "option");

      var link = document.createElement("a");
      link.href = product.url;
      link.className = "predictive-search-product";

      if (product.image) {
        var img = document.createElement("img");
        img.src = product.image;
        img.alt =
          (product.featured_image && product.featured_image.alt) ||
          product.title;
        img.className = "predictive-search-product__image";
        link.appendChild(img);
      }

      var infoWrap = document.createElement("div");
      infoWrap.className = "predictive-search-product__info";

      var title = document.createElement("div");
      title.className = "predictive-search-product__title";
      title.textContent = product.title;

      var price = document.createElement("div");
      price.className = "predictive-search-product__price";
      price.textContent = product.price; // already formatted like "129,00" on your store

      infoWrap.appendChild(title);
      infoWrap.appendChild(price);

      var cta = document.createElement("span");
      cta.className = "btn";
      cta.textContent = "Buy Now";

      link.appendChild(infoWrap);
      link.appendChild(cta);

      li.appendChild(link);
      resultsList.appendChild(li);
    });

    // "See more results" link
    if (currentQuery) {
      moreLink.href = "/search?q=" + encodeURIComponent(currentQuery);
    }

    // Show / hide wrapper
    if (!products.length && !suggestions.length && !collections.length) {
      wrapper.hidden = true;
    } else {
      wrapper.hidden = false;
      // re-position relative to header
      positionDropdown();
    }
  }

  // 🔧 Position dropdown under header.header .header__top
  function positionDropdown() {
    var headerTop = document.querySelector(".header.header .header__top");
    if (!headerTop || !wrapper) return;

    var rect = headerTop.getBoundingClientRect();
    var offset = rect.bottom + window.scrollY;

    wrapper.style.position = "absolute";
    wrapper.style.top = offset + "px";
    wrapper.style.left = 0;
    wrapper.style.right = 0;
  }

  window.addEventListener("resize", positionDropdown);
  window.addEventListener("scroll", positionDropdown);
});